<template>
  <div class="edit-ads">
    <el-dialog title="Edit" :visible.sync="dialogFormVisible" width="530px" label-position="top">
      <el-form :model="form" :rules="rules" ref="form" :show-message="false" status-icon>
        <el-form-item label="AD description" prop="description">
          <el-input v-model="form.description" type="text" placeholder="Input the AD description"></el-input>
        </el-form-item>
        <el-form-item label="Priority" prop="priority">
          <el-select v-model="form.priority" placeholder="">
            <el-option
                v-for="(item, index) in optionList"
                :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Upload a picture (1029*558)" required prop="picture">
          <ra-img-upload :width="339" :height="184" v-model="form.picture" class="mt-12" @outSizeHandle="outSizeHandle" :uploadApiPath="'adminapi/uploadAdImage'"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelHandler" plain class="w-[80px] changeFocus p-0 border-black text-black">Cancel</el-button>
        <el-button type="success" @click="submitHandler" class="w-[80px] p-0">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import raImgUpload from "@/components/ra-img-upload.vue";
import {updateAd} from "@/api/ads";
export default {
  props: {
    rowData: Object
  },
  components: {
    raImgUpload
  },
  data() {
    return {
      optionList: [
        { label: 1, value: 1 },
        { label: 2, value: 2 }
      ],
      rules: {
        description: [
          {required: true}
        ],
        priority: [
          {required: true}
        ],
        picture:[
          {required: true}
        ]
      },
      form: {
        description: '',
        priority: 0,
        picture: ''
      },
      dialogFormVisible: false
    }
  },
  methods: {
    cancelHandler() {
      this.dialogFormVisible = false
    },
    outSizeHandle(val){
      console.log(val,'ddddddd')
      this.form.size = val
    },
    submitHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updateAd(this.form).then(response => {
            if (response.code === 200) {
              this.$emit('updateList');
              this.$message.success('update success');
              this.dialogFormVisible = false;
            } else {
              this.$message.error(response.msg);
            }
          })
        }else{
          this.$message({
            message:"Some information missing",
            type:'warning'
          })
        }
      })
    },
  },
  watch: {
    dialogFormVisible(val) {
      if (!val) {
        this.$refs.form.clearValidate();
        this.$refs.form.resetFields();
      } else {
        this.form = {...this.rowData}
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>
